import { Timeframe } from 'interfaces/chart'
import { IdValueEntity } from 'interfaces/index'
import { InsightsPageType } from 'interfaces/pages'

export const EARLIEST_DATA_DATE = '2015-02-01'

export const DATE_FORMAT_US = 'MM/DD/YYYY'
export const DATE_FORMAT_ISO_FULL = 'YYYY-MM-DD'
export const DATE_FORMAT_ISO_DAYLESS = 'YYYY-MM'
export const DATE_FORMAT_READABLE = 'MMM DD, YYYY'
export const DATE_FORMAT_READABLE_YEARLESS = 'MMM Do'
export const DATE_FORMAT_CARD_EXPIRATION = 'MM/YYYY'

export const ALL_TIMEFRAMES = ['current-month', 'last-month', '6-months', '13-months']

export const HISTORICAL_TIMEFRAMES = ['last-month']

export const FUTURE_TIMEFRAMES = ['future', 'next-10-years', 'next-20-years', 'next-30-years']

export const TIMEFRAME_TYPES: IdValueEntity<Timeframe, string>[] = [
  { id: 'current-month', value: 'Current Month' },
  { id: 'last-month', value: 'Last Month' },
  { id: '6-months', value: 'Last 6 months' },
  { id: '13-months', value: 'Last 13 months' },
]

export const FUTURE_TIMEFRAME_TYPES: IdValueEntity<Timeframe, string>[] = [
  { id: 'future', value: 'Future' },
  { id: 'next-10-years', value: 'Next 10 Years' },
  { id: 'next-20-years', value: 'Next 20 years' },
  { id: 'next-30-years', value: 'Next 30 years' },
]

export const TREND_TITLE_MAP: Record<Timeframe, string> = {
  'current-month': 'the Current Month',
  'last-month': 'the Last Month',
  '6-months': 'the Last 6 Months',
  '13-months': 'the Last 13 Months',
  future: 'Future',
  'next-10-years': 'the Next 10 Years',
  'next-20-years': 'the Next 20 Years',
  'next-30-years': 'the Next 30 Years',
}

export const DEFAULT_TIMEFRAMES: Record<InsightsPageType, Timeframe> = {
  // TODO: remove this by refactoring page type system
  feedposts:      'current-month',
  feedpost:       'current-month',
  feedauthor:     'current-month',
  feedtag:        'current-month',
  dashboard:      'current-month',
  transactions:   '6-months',
  spending:       '6-months',
  income:         '6-months',
  debts:          '6-months',
  assets:         '6-months',
  networth:       '6-months',
  creditscore:    '6-months',
  future:         'future',
  coaching:       'future',
  creditcard:     'current-month',
}

